import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Requests from "./pages/Requests";
import CreateRequest from "./pages/CreateRequest";
import Payments from "./pages/Payments";
import Diagnostics from "./pages/Diagnostics";

// =====================================================
// 🔐 AUTH PROTECTION (TOKEN)
// =====================================================
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

// =====================================================
// 👑 ADMIN ONLY ROUTE
// =====================================================
const AdminRoute = ({ children }) => {
  const role = localStorage.getItem("userRole");

  if (role !== "admin") {
    return <Navigate to="/requests" replace />;
  }

  return children;
};

// =====================================================
// 🚀 MAIN ROUTES
// =====================================================
const App = () => {
  return (
    <Router>
      <Routes>
        {/* 🔓 Public */}
        <Route path="/login" element={<Login />} />

        {/* 👑 ADMIN ROUTES */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <AdminRoute>
                <Dashboard />
              </AdminRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <AdminRoute>
                <Users />
              </AdminRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/payments"
          element={
            <ProtectedRoute>
              <AdminRoute>
                <Payments />
              </AdminRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/diagnostics"
          element={
            <ProtectedRoute>
              <AdminRoute>
                <Diagnostics />
              </AdminRoute>
            </ProtectedRoute>
          }
        />

        {/* 🛠 TECHNICIAN + ADMIN */}
        <Route
          path="/requests"
          element={
            <ProtectedRoute>
              <Requests />
            </ProtectedRoute>
          }
        />

        {/* 🛠 CREATE REQUEST — Admin only */}
        <Route
          path="/requests/create"
          element={
            <ProtectedRoute>
              <AdminRoute>
                <CreateRequest />
              </AdminRoute>
            </ProtectedRoute>
          }
        />

        {/* Default */}
        <Route path="/" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
